import { render, staticRenderFns } from "./PageBindSuccess.vue?vue&type=template&id=bf6cc062&scoped=true"
import script from "./PageBindSuccess.vue?vue&type=script&lang=js"
export * from "./PageBindSuccess.vue?vue&type=script&lang=js"
import style0 from "./PageBindSuccess.vue?vue&type=style&index=0&id=bf6cc062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6cc062",
  null
  
)

export default component.exports